import axios from 'axios'
import {
  SET_LIST_MESSAGE,
  SET_MESSAGE_VERSION
} from '@/store/mutation-types'

const fetchMessages = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  axios.get('messages', { params: {limit: 1000, ...params} }).then(response => {
    if (response.status === 1) {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_LIST_MESSAGE, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const getMessageNotification = ({commit, dispatch}) => {
  dispatch('toggleLoadding', true, {root: true})
  axios.get('messages/notification').then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(SET_MESSAGE_VERSION, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
    }
  })
}

const setMessages = ({commit}, data) => {
  commit(SET_LIST_MESSAGE, data)
}

const setNotification = ({commit}, data) => {
  commit(SET_MESSAGE_VERSION, data)
}

export default{
  fetchMessages,
  setMessages,
  getMessageNotification,
  setNotification
}



// WEBPACK FOOTER //
// ./src/components/message/store/actions.js